module.exports = "pegasus/assets/tech/email1-gallery-img2.png";